import { render, staticRenderFns } from "./effraction.vue?vue&type=template&id=6680afaa"
import script from "./effraction.vue?vue&type=script&lang=ts"
export * from "./effraction.vue?vue&type=script&lang=ts"
import style0 from "./effraction.vue?vue&type=style&index=0&id=6680afaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports